var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":function($event){return _vm.$root.$emit('bv::hide::popover')}}},[_c('div',{staticClass:"container"},[(_vm.errorMessage)?_c('b-alert',{attrs:{"show":"","variant":"danger","dismissible":""}},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")]):_vm._e(),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }